import React from 'react';
import { useEffect } from 'react';
import { useState } from 'react';
import DisplayCard from './DisplayCard';

const Block = (props) => {
  const {
    selectedValue,
    handleQuickStatus,
    loading,
    count,
    lableText,
    nonClickable,
    value,
  } = props;

  const [selected, setSelected] = useState(false);

  useEffect(() => {
    if (value) {
    if (selectedValue !== value) {
      setSelected(false);
    } else {
      setSelected(true);
    }
    }
  }, [selectedValue, value]);

  const handleClick = () => {
    setSelected(true);
    handleQuickStatus(value);
  };

  return (
    <DisplayCard
      tertiaryText={null}
      secondaryText={lableText}
      primaryText={count}
      loading={loading}
      selected={selected}
      handleClick={nonClickable ? null : handleClick}
    />
  );
};

export default React.memo(Block);
